export const GRID_DETAIL_ROW_PREFIX = 'z-grid-detail-row'

export function buildGridDetailRowKey(module: string, id: string | number) {
  return `${GRID_DETAIL_ROW_PREFIX}:${module}:${id}`
}

export function saveGridDetailRow(
  module: string,
  id: string | number,
  row: Record<string, unknown>
) {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  sessionStorage.setItem(buildGridDetailRowKey(module, id), JSON.stringify(row))
}

export function readGridDetailRow(
  module: string,
  id: string | number | null | undefined
): Record<string, unknown> | null {
  if (id == null || id === '' || typeof sessionStorage === 'undefined') {
    return null
  }
  const raw = sessionStorage.getItem(buildGridDetailRowKey(module, String(id)))
  if (!raw) {
    return null
  }
  try {
    return JSON.parse(raw) as Record<string, unknown>
  } catch {
    return null
  }
}

export function resolveDetailRowQueryValue(
  raw: unknown
): string | number | null {
  if (raw == null || raw === '') {
    return null
  }
  const value = Array.isArray(raw) ? raw[0] : raw
  if (value == null || value === '') {
    return null
  }
  const num = Number(value)
  return Number.isNaN(num) ? String(value) : num
}

/** 从 vue-router query（或同等结构）解析 passRow 详情页的 module + id */
export function resolveDetailRowFromQuery(
  query: Record<string, unknown>
): { module: string; id: string | number | null } {
  const moduleRaw = query.module
  const module =
    moduleRaw == null || moduleRaw === ''
      ? ''
      : String(Array.isArray(moduleRaw) ? moduleRaw[0] : moduleRaw)
  return {
    module,
    id: resolveDetailRowQueryValue(query.id),
  }
}

export function resolveDetailRowId(
  params: Record<string, unknown>
): string | number | null {
  return resolveDetailRowQueryValue(params.id)
}
